export default __webpack_public_path__ + "4c58465f16cce8ea5dd34459d1f227a6.svg";